import { observer } from 'mobx-react-lite';
import { IconButton } from 'office-ui-fabric-react/lib/Button';
import { ControlIcons } from 'owa-control-icons';
import loc from 'owa-localize';
import * as React from 'react';
import {
    markAsNotCompletedLabel,
    markAsCompletedLabel,
} from './CommonTodoViewStrings.locstring.json';

const styles = require('./CompleteCheckbox.scss');
const classNames = require('classnames/bind').bind(styles);

export interface CompleteCheckboxProps {
    isComplete: boolean;
    onToggleComplete?: () => any;
    checkboxClassName?: string;
}

export default observer(function CompleteCheckbox({
    isComplete,
    onToggleComplete,
    checkboxClassName,
}: CompleteCheckboxProps) {
    const title = isComplete ? loc(markAsNotCompletedLabel) : loc(markAsCompletedLabel);

    const onClick = React.useCallback(
        (evt: React.MouseEvent<unknown>) => {
            evt.stopPropagation();
            if (onToggleComplete) {
                onToggleComplete();
            }
        },
        [onToggleComplete]
    );

    return (
        <IconButton
            className={classNames(styles.checkBox, {
                completed: isComplete,
            })}
            iconProps={{
                iconName: ControlIcons.CheckMark,
                className: classNames(styles.checkMarkCircle, checkboxClassName),
            }}
            aria-label={title}
            onClick={onClick}
            title={title}
            checked={isComplete}
            toggle={true}
        />
    );
});
